import { readonly, shallowRef, watch } from 'vue'

const isActive = shallowRef(false)
const text = shallowRef('')

watch(isActive, (value) => {
  if (!value) {
    text.value = ''
  }
})

export function useSnackbar() {
  function close() {
    isActive.value = false
  }

  function show(message?: string) {
    if (message) {
      text.value = message
    }

    isActive.value = true
  }

  return {
    isActive,
    text: readonly(text),
    close,
    show,
  }
}
